import { getEnvVariable } from './get-env-variable';

const PROD_BOOT_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAE1qiWxioYeQDWppM2V/UhBVmnDV/n
qJ6lQR4xK2LnJbJzyJJSKVAMnz+d+TNBa7RaCcokYylCy/y6vha2cFuJ5Q==
-----END PUBLIC KEY-----`;

const SANDBOX_BOOT_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEpZO5kt1kzT2RJoVwD5ZF9BspfTmk
msLX8ePBQ2MGgpsvyNlOUBbWgIv15UQcB6HD5w9tIwYrQ+OONNekYu+u1A==
-----END PUBLIC KEY-----`;

const STAGING_BOOT_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEm8kYe/OdQdMwdN2AfN3otwaXV1dS
SWgMlYnN+VILFfLdeDIJblD1MSEFzaqe4Jpw6cb0J1OvDtu4qBUmXkwkIQ==
-----END PUBLIC KEY-----`;

export function getBootPublicKey(): string {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : undefined;
  const env = getEnvVariable('VITE_ENV')?.toLowerCase();

  if (hostname === 'pay.appcharge.com' || env === 'prod' || env === 'production') {
    return PROD_BOOT_PUBLIC_KEY;
  }

  if (hostname === 'pay-sandbox.appcharge.com' || env === 'sandbox') {
    return SANDBOX_BOOT_PUBLIC_KEY;
  }

  return STAGING_BOOT_PUBLIC_KEY;
}
